import React from 'react';

export const TagsDisplay = ({ tags }) => {
  if (!tags || tags.length === 0) return null;

  return (
    <div style={styles.container}>
      <span style={styles.label}>🏷️ Теги:</span>
      <div style={styles.tagsList}>
        {tags.map(tag => (
          <span key={tag.pk_tag} style={styles.tag}>
            {tag.title}
          </span>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 16px',
    background: 'rgba(155, 89, 182, 0.08)',
    border: '1px solid rgba(155, 89, 182, 0.2)',
    borderRadius: '8px',
    marginTop: '15px',
    flexWrap: 'wrap'
  },
  label: {
    color: '#9b59b6',
    fontSize: '0.9rem',
    fontWeight: 600,
    fontFamily: 'Special Elite, monospace'
  },
  tagsList: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap'
  },
  tag: {
    background: 'rgba(155, 89, 182, 0.15)',
    border: '1px solid rgba(155, 89, 182, 0.3)',
    color: '#9b59b6',
    padding: '4px 12px',
    borderRadius: '16px',
    fontSize: '0.85rem',
    fontWeight: 500,
    transition: 'all 0.2s'
  }
};